import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
import { SmartphoneIcon, ArrowRightIcon } from 'lucide-react';
export function PuttLabPlayPage() {
  return <div className="w-full pt-24 bg-brand-charcoal text-brand-cream-light" data-id="element-807">
      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-808">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#B8965A_1px,transparent_1px)] [background-size:40px_40px]" data-id="element-809" />
        <div className="max-w-7xl mx-auto px-6 relative z-10 text-center" data-id="element-810">
          <SectionHeading eyebrow="Digital Layer" title="PuttLab Play" subtitle="Turn a physical amenity into a connected digital experience. Scan, play, score, and share." align="center" light data-id="element-811" />

          <ScrollReveal delay={0.2} data-id="element-812">
            <div className="mt-12 inline-block" data-id="element-813">
              <a href="#/play/app" className="group relative inline-flex items-center justify-center px-8 py-5 text-lg font-heading text-brand-charcoal bg-brand-gold rounded-xl overflow-hidden shadow-[0_0_40px_rgba(184,150,90,0.3)] hover:shadow-[0_0_60px_rgba(184,150,90,0.5)] transition-all duration-300 hover:-translate-y-1" data-id="element-814">
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-815" />
                <span className="relative flex items-center space-x-3" data-id="element-816">
                  <SmartphoneIcon className="w-6 h-6" data-id="element-817" />
                  <span data-id="element-818">Try the Interactive App Demo</span>
                  <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-819" />
                </span>
              </a>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="py-24" data-id="element-820">
        <div className="max-w-7xl mx-auto px-6" data-id="element-821">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-822">
            <ScrollReveal data-id="element-823">
              <div className="space-y-12" data-id="element-824">
                <div data-id="element-825">
                  <h3 className="text-2xl font-heading text-brand-gold mb-3" data-id="element-826">
                    1. Scan to Play
                  </h3>
                  <p className="font-body text-brand-cream/70" data-id="element-827">
                    Guests scan a beautifully integrated QR code at the start of
                    the green to instantly launch the web app. No downloads
                    required.
                  </p>
                </div>
                <div data-id="element-828">
                  <h3 className="text-2xl font-heading text-brand-gold mb-3" data-id="element-829">
                    2. Choose Game Mode
                  </h3>
                  <p className="font-body text-brand-cream/70" data-id="element-830">
                    Select from standard stroke play, match play, or custom
                    challenges designed specifically for your layout.
                  </p>
                </div>
                <div data-id="element-831">
                  <h3 className="text-2xl font-heading text-brand-gold mb-3" data-id="element-832">
                    3. Digital Scorecard
                  </h3>
                  <p className="font-body text-brand-cream/70" data-id="element-833">
                    An elegant, easy-to-use interface to track strokes for the
                    whole group as they navigate the course.
                  </p>
                </div>
                <div data-id="element-834">
                  <h3 className="text-2xl font-heading text-brand-gold mb-3" data-id="element-835">
                    4. Share & Compete
                  </h3>
                  <p className="font-body text-brand-cream/70" data-id="element-836">
                    Generate branded winner cards for Instagram, and view
                    property-wide leaderboards for the day, week, or all-time.
                  </p>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal direction="left" data-id="element-837">
              <div className="flex justify-center space-x-6" data-id="element-838">
                {/* Phone Mockup 1 */}
                <div className="w-48 h-96 bg-brand-green-deep rounded-[2rem] border-4 border-brand-dark-gray shadow-2xl p-4 flex flex-col mt-12" data-id="element-839">
                  <div className="text-center mb-4 mt-4" data-id="element-840">
                    <h4 className="font-heading text-brand-gold text-sm" data-id="element-841">
                      Leaderboard
                    </h4>
                  </div>
                  <div className="space-y-2 flex-1" data-id="element-842">
                    {[1, 2, 3, 4, 5].map(i => <div key={i} className="bg-brand-cream/10 rounded p-2 flex justify-between text-xs font-body" data-id="element-843">
                        <span data-id="element-844">Player {i}</span>
                        <span className="text-brand-gold" data-id="element-845">
                          -{Math.floor(Math.random() * 5)}
                        </span>
                      </div>)}
                  </div>
                </div>
                {/* Phone Mockup 2 */}
                <div className="w-56 h-[28rem] bg-brand-green-deep rounded-[2rem] border-4 border-brand-dark-gray shadow-2xl p-4 flex flex-col -mt-12" data-id="element-846">
                  <div className="text-center mb-6 mt-6" data-id="element-847">
                    <h4 className="font-heading text-brand-gold text-xl" data-id="element-848">
                      Winner
                    </h4>
                    <p className="text-[10px] text-brand-cream/50 uppercase tracking-widest mt-1" data-id="element-849">
                      The Resort Green
                    </p>
                  </div>
                  <div className="flex-1 bg-brand-gold/20 rounded-xl border border-brand-gold/30 flex items-center justify-center flex-col" data-id="element-850">
                    <span className="text-5xl font-heading mb-2" data-id="element-851">68</span>
                    <span className="text-xs uppercase tracking-widest text-brand-gold" data-id="element-852">
                      Course Record
                    </span>
                  </div>
                  <div className="mt-4 bg-brand-gold text-brand-charcoal text-center py-2 rounded-lg text-xs font-bold" data-id="element-853">
                    Share to Story
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <section className="py-24 text-center" data-id="element-854">
        <Button variant="primary" size="lg" href="/contact" data-id="element-855">
          Add Play to Your Project
        </Button>
      </section>
    </div>;
}